
import { i18n } from 'i18next'
import { useTranslation } from 'react-i18next'
import { useCurrencySign } from 'hooks/useCurrency'
import { OptionTier } from '@order/steps/types'
import { StepOption } from '@order/steps/types'
import { Discountable } from '@order/utils/discounts/Discounts'


export const getCTA = (cta: StepOption['cta']) => {
  if (cta === 'select') return 'ui:select'
  return undefined
}

export const useGetLabel = ({
  label,
  price,
  recommended,
}: {
  label: StepOption['label']
  price: Discountable | undefined
  recommended: StepOption['recommended']
}) => {
  const { t } = useTranslation(['ui-steps'])
  const currency = useCurrencySign()

  const isDiscounted = price?.applied && price.applied.length > 0

  if (isDiscounted) {
    const discount = price?.applied
      ?.map(
        ({ amount, type }) =>
          `${amount}${type === 'percentage' ? '%' : currency}`
      )
      .join(', ')

    return t('ui-steps:option.label.discount', { discount })
  }

  if (recommended) return t('ui-steps:option.label.recommended')

  return label || undefined
}

export const resolveTier = (value?: string | null): OptionTier => {
  if (!value) {
    return 'standard'
  }

  if (value in OptionTier) {
    return value as OptionTier
  }

  return 'standard'
}

export const resolvePoints = (i18n: i18n, lookup: string[]) => {
  const validPrefix = lookup.find((l) => i18n.exists(`${l}.points.0`))

  if (!validPrefix) {
    return []
  }

  const points: string[] = []

  for (let i = 0; i < 5; i++) {
    const key = `${validPrefix}.points.${i}`
    if (!i18n.exists(key)) {
      break
    }
    points.push(i18n.t(key))
  }

  return points
}